import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import RefreshIcon from '@material-ui/icons/Refresh';
import ScheduleIcon from '@material-ui/icons/Schedule';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import TuneIcon from '@material-ui/icons/Tune';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import deepMerge from 'deepmerge';

import DataTable from 'Components/DataTable';
import Button from 'Common/CustomButtons/Button';
import Loader from 'Common/Loader/Loader';

import { formatDate } from 'Utils';
import { pageTitleDecorator, authenticatedPageDecorator, aclDecorator } from 'Decorators';
import { QueryFilterType, SubmissionType, DataTableMetadataType, JournalType, ProfileType } from 'Types';
import {
    DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_SINGLE,
    DATA_TABLE_COLUMN_TYPE_HIDDEN,
    DATA_TABLE_FILTER_TYPE_DATE,
    DATA_TABLE_FILTER_TYPE_SELECT,
    PHASE_PUBLISHED,
    DATA_TABLE_FILTER_TYPE_COMPLEX_STRING,
    ROLE_ADMIN,
    ROLE_CHIEF_EDITORIAL,
    ROLE_EDITORIAL,
    DATA_TABLE_COLUMN_TYPE_LINK,
    DATA_TABLE_COLUMN_TYPE_AUTHOR,
    DATA_TABLE_COLUMN_TYPE_PROCESS_STATUS,
    ROLE_AUTHOR,
    ROLE_REVIEWER,
    DATA_TABLE_COLUMN_TYPE_ICON_STATUS,
    ROLE_EDITOR,
    ROLE_EDITORIAL_BOARD,
    ASSIGN_STATUS_ACCEPTED,
} from 'Constants';
import { loadAutocomplete as journalLoadAutocomplete } from 'Actions/journal';
import { loadAutocomplete as profileLoadAutocomplete } from 'Actions/profile';
import {
    load,
    updateFilter,
    updateSearchFilter,
    loadAutocomplete,
    loadStatuses,
    loadPhases,
    loadCount,
    clearSubmissionList,
} from 'Actions/submission';
import { push } from 'react-router-redux';

const styles = () => ({
    hidden: {
        display: 'none',
    },
});

@aclDecorator()
@authenticatedPageDecorator()
@withStyles(styles)
@pageTitleDecorator('submissions')
@connect(
    store => ({
        loading: store.submissionsList.loading,
        success: store.submissionsList.success,
        error: store.submissionsList.error,
        data: store.submissionsList.data,
        filter: store.submissionsList.filter,
        tmpFilter: store.submissionsList.tmpFilter,
        metadata: store.submissionsList.metadata,
        dataAutocomplete: store.submissionsListAutocomplete.data,
        filterAutocomplete: store.submissionsListAutocomplete.filter,
        journalsFilterAutocomplete: store.journalsListAutocomplete.filter,
        journalDataAutocomplete: store.journalsListAutocomplete.data,
        profilesFilterAutocomplete: store.profilesAutocomplete.filter,
        profileDataAutocomplete: store.profilesAutocomplete.data,
        statusesData: store.submissionStatuses.data,
        phasesData: store.submissionPhases.data,
        countData: store.submissionsCount.data,
        user: store.auth.user,
        userId: store.auth.user.id,
    }),
    dispatch => ({
        load: filter => dispatch(load(filter)),
        updateFilter: filter => dispatch(updateFilter(filter)),
        updateSearchFilter: filter => dispatch(updateSearchFilter(filter)),
        clearSubmissionList: () => dispatch(clearSubmissionList()),
        loadAutocomplete: filter => dispatch(loadAutocomplete(filter)),
        journalLoadAutocomplete: filter => dispatch(journalLoadAutocomplete(filter)),
        profileLoadAutocomplete: filter => dispatch(profileLoadAutocomplete(filter)),
        loadStatuses: () => dispatch(loadStatuses()),
        loadPhases: () => dispatch(loadPhases()),
        loadCount: filter => dispatch(loadCount(filter)),
        redirectToCreate: () => dispatch(push('/submissions/create')),
    })
)
export default class SubmissionsList extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        loading: PropTypes.bool.isRequired,
        success: PropTypes.bool.isRequired,
        error: PropTypes.bool.isRequired,
        data: PropTypes.arrayOf(SubmissionType),
        filter: QueryFilterType,
        tmpFilter: QueryFilterType,
        metadata: DataTableMetadataType,
        load: PropTypes.func.isRequired,
        updateFilter: PropTypes.func.isRequired,
        updateSearchFilter: PropTypes.func.isRequired,
        clearSubmissionList: PropTypes.func.isRequired,
        filterAutocomplete: QueryFilterType,
        dataAutocomplete: PropTypes.arrayOf(SubmissionType),
        loadAutocomplete: PropTypes.func,
        journalDataAutocomplete: PropTypes.arrayOf(JournalType),
        journalsFilterAutocomplete: QueryFilterType,
        journalLoadAutocomplete: PropTypes.func,
        profileDataAutocomplete: PropTypes.arrayOf(ProfileType),
        profilesFilterAutocomplete: QueryFilterType,
        profileLoadAutocomplete: PropTypes.func,
        loadStatuses: PropTypes.func,
        statusesData: PropTypes.array,
        loadPhases: PropTypes.func,
        phasesData: PropTypes.array,
        loadCount: PropTypes.func,
        countData: PropTypes.object,
        user: PropTypes.object,
        isOneOf: PropTypes.func.isRequired,
        is: PropTypes.func.isRequired,
        userId: PropTypes.number,
        redirectToCreate: PropTypes.func.isRequired,
    };

    /**
     * @type {Object}
     */
    state = {
        isOverdue: false,
        isNew: false,
        isFiltersOpen: false,
        submissionsType: 'active',
        allJournals: false,
        authors: '',
        title: '',
        filtersKey: Math.random(),
        role: ''
    };

    /**
     * Component Did Mount
     */
    componentDidMount() {
        const { loadStatuses, loadPhases, loadCount, updateFilter, user: { activeRole: { journals } } } = this.props;
        updateFilter({ where: {status: this.getSubmissionType()}, has: {} });
        loadStatuses();
        loadPhases();
        loadCount(this.getAuthCountFilter(journals));
        //this.setDefaultOrder();
    }

    componentWillReceiveProps(nextProps) {
        const { user: { activeRole : { role, journals } } } = nextProps;
        if (this.state.role !== role) {
            this.setState({ role });
            this.props.loadCount(this.getAuthCountFilter(journals));
            this.loadJournalOptions('', journals);
            this.loadProfileOptions('', journals);
            this.loadOptions({'submissions.id': { like: '%%' }});
        }
    }

    componentWillUnmount() {
        const { clearSubmissionList } = this.props;
        clearSubmissionList();
    }

    resetToDefault() {
        this.toggleStatus(false, false);
        this.resetFilters(true);
        this.resetSearchFilters();
        this.setDefaultOrder();
        this.setState({ filtersKey: Math.random() });
    }

    setDefaultOrder() {
        const { updateFilter } = this.props;
        updateFilter({ order: 'default desc' });
    }

    resetSearchFilters() {
        const { updateSearchFilter } = this.props;
        updateSearchFilter({ where: {} });
        this.setState({
            title: '',
            authors: '',
        });
    }

    resetFilters(clear = false) {
        const { updateFilter } = this.props;
        if (clear) {
            this.setState({submissionsType: 'active'});
        }

        updateFilter({ where: {status: this.getSubmissionType(clear)}, has: {} });
    }

    getSubmissionType(isClear = false) {
        const { is } = this.props;
        const { submissionsType } = this.state;
        return is(ROLE_AUTHOR) ? 'all' : (isClear ? 'active' : submissionsType);
    }

    toggleStatus(isOverdue, isNew) {
        this.setState(
            {
                isOverdue: isOverdue ? !this.state.isOverdue : false,
                isNew: isNew ? !this.state.isNew : false,
            },
            () => this.updateFilterByStatus()
        );
    }

    updateFilterByStatus() {
        const {
            updateFilter,
            filter: { where: currentWhere },
        } = this.props;
        let where = { ...currentWhere };
        delete where.is_overdue;
        delete where.is_new;

        if (this.state.isOverdue) {
            where.is_overdue = 1;
        } else if (this.state.isNew) {
            where.is_new = 1;
        }

        updateFilter({ where: where });
    }

    toggleJournals(allJournals) {
        this.resetSearchFilters();
        this.setDefaultOrder();
        this.setState(
            {
                allJournals,
                submissionsType: 'active',
            },
            () => {
                const { updateFilter } = this.props;
                const { allJournals } = this.state;
                updateFilter({
                    where: {status: this.getSubmissionType()},
                    search: allJournals ? 1 : 0,
                });
            }
        );
    }

    handleChangeSearch(key, value) {
        const {
            updateSearchFilter,
            tmpFilter: { where: currentWhere },
        } = this.props;
        let where = { ...currentWhere };
        where[key] = value;
        updateSearchFilter({ where: where });
    }

    getUserJournals = () => {
        const { isOneOf, user: {activeRole: {journals}} } = this.props;
        if (isOneOf([ROLE_EDITORIAL, ROLE_EDITOR, ROLE_EDITORIAL_BOARD, ROLE_REVIEWER])) {
            return journals;
        } else {
            return [];
        }
    };

    getAuthFilter = (filter) => {
        const { isOneOf, is, userId } = this.props;
        let authFilter = filter;
        if (is(ROLE_AUTHOR)) {
            authFilter = deepMerge(filter, { where: { user_id: userId, status: this.getSubmissionType() } });
        } else if (isOneOf([ROLE_REVIEWER, ROLE_EDITORIAL_BOARD])) {
            authFilter = deepMerge(filter, { has: { reviewers: { where: { user_id: userId, status: ASSIGN_STATUS_ACCEPTED }}}});
        } else if (is(ROLE_EDITORIAL)) {
            authFilter = deepMerge(filter, { where: { journal_id: {inq: this.getUserJournals()} } });
        } else if (is(ROLE_EDITOR)) {
            authFilter = deepMerge(filter, { where: { journal_id: {inq: this.getUserJournals()}, 'submissions.user_id': {neq: userId} }});
        }

        return authFilter;
    };

    getAuthCountFilter = (journals) => {
        const { isOneOf, is, userId } = this.props;

        let filter = {};
        if (is(ROLE_EDITOR)) {
            filter = { where: { journal_id: {inq: journals}, user_id: {neq: userId} } };
        } else if (isOneOf([ROLE_EDITORIAL, ROLE_EDITORIAL_BOARD, ROLE_REVIEWER])) {
            filter = { where: { journal_id: {inq: journals} } };
        }

        return filter;
    };

    loadOptions = where => {
        const { filterAutocomplete, loadAutocomplete } = this.props;
        loadAutocomplete(this.getAuthFilter(filterAutocomplete.merge({ where })));
    };

    loadJournalOptions = (input, journals = []) => {
        const { journalsFilterAutocomplete, journalLoadAutocomplete, isOneOf } = this.props;
        const filter = journalsFilterAutocomplete.merge({
            where: {
                title: { like: `%${input}%` },
            },
        });

        let authFilter = filter;
        if (isOneOf([ROLE_EDITORIAL, ROLE_EDITOR, ROLE_EDITORIAL_BOARD, ROLE_REVIEWER])) {
            authFilter = deepMerge(filter, { where: { id: {inq: journals && journals.length ? journals : this.getUserJournals()} } });
        }

        journalLoadAutocomplete(authFilter);
    };

    loadProfileOptions = (input, journals = []) => {
        const { profilesFilterAutocomplete, profileLoadAutocomplete, isOneOf } = this.props;
        let has = {};
        if (isOneOf([ROLE_EDITORIAL, ROLE_EDITOR, ROLE_EDITORIAL_BOARD, ROLE_REVIEWER])) {
            has = {'submission': {where: {'journal_id': {inq: journals && journals.length ? journals : this.getUserJournals()}}}};
        } else {
            has = 'submission';
        }

        profileLoadAutocomplete(profilesFilterAutocomplete.merge({ where: {full_name: input}, has: has }));
    };

    getColumns = () => {
        const { submissionsType } = this.state;
        const {
            dataAutocomplete,
            journalDataAutocomplete,
            profileDataAutocomplete,
            statusesData,
            phasesData,
            tmpFilter: { where },
            isOneOf
        } = this.props;

        return [
            {
                key: 'icon',
                col: { width: '3%' },
                title: 'data_table.empty',
                sortable: false,
                filterable: false,
                type: DATA_TABLE_COLUMN_TYPE_ICON_STATUS,
            },
            {
                key: 'id',
                col: { width: '3%' },
                filterKey: 'id',
                title: 'data_table.id',
                sortable: true,
                filterable: false,
                options: dataAutocomplete.map(item => ({
                    value: item.id,
                    label: 'MA' + item.id,
                })),
            },
            {
                key: 'title',
                col: { width: '25%' },
                filterKey: 'submissions.id',
                title: 'data_table.title',
                sortable: true,
                filterable: true,
                type: DATA_TABLE_COLUMN_TYPE_LINK,
                link: {
                    to: ':link',
                    placeholders: {
                        link: item => {
                            return this.props.isOneOf([ROLE_AUTHOR, ROLE_REVIEWER, ROLE_EDITORIAL_BOARD]) ||
                                this.props.isOneOf([ROLE_ADMIN, ROLE_CHIEF_EDITORIAL, ROLE_EDITORIAL, ROLE_EDITOR], item.journal_id)
                                ? `/submissions/${item.realId}`
                                : '#';
                        },
                    },
                },
                options: dataAutocomplete.map(item => ({
                    value: item.id,
                    label: item.title,
                })),
                loadOptions: input =>
                    this.loadOptions({
                        'submissions.title': { like: `%${input}%` },
                    }),
                filterType: DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_SINGLE,
                filterPlaceholder: 'data_table.filter.title',
                filterSize: 6,
                filterClassName: 'submissions-filter-title',
            },
            {
                key: 'authors',
                col: { width: '11%' },
                title: 'data_table.authors',
                sortable: false,
                filterable: false,
                filterSize: 3,
                type: isOneOf([ROLE_REVIEWER, ROLE_EDITORIAL_BOARD]) ? DATA_TABLE_COLUMN_TYPE_HIDDEN : DATA_TABLE_COLUMN_TYPE_AUTHOR,
            },
            {
                key: 'profiles.full_name',
                sortable: false,
                filterable: true,
                type: DATA_TABLE_COLUMN_TYPE_HIDDEN,
                options: profileDataAutocomplete,
                loadOptions: this.loadProfileOptions,
                filterType: DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_SINGLE,
                filterPlaceholder: 'data_table.filter.author.title',
                relation: 'profiles',
                filterClassName: 'submissions-filter-authors',
            },
            {
                key: 'journal.title',
                col: { width: '20%' },
                title: 'data_table.journal_id',
                sortable: true,
                filterable: false,
            },
            {
                key: 'journals.id',
                sortable: false,
                filterable: true,
                type: DATA_TABLE_COLUMN_TYPE_HIDDEN,
                options: journalDataAutocomplete.map(item => ({
                    value: item.id,
                    label: item.title,
                })),
                loadOptions: this.loadJournalOptions,
                filterType: DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_SINGLE,
                filterPlaceholder: 'data_table.filter.journal.title',
                relation: 'journal',
                filterSize: 3,
                filterClassName: 'submissions-filter-journals',
            },
            {
                key: 'filter_id',
                filterKey: 'submissions.id',
                title: 'data_table.id',
                sortable: true,
                filterable: true,
                options: dataAutocomplete.map(item => ({
                    value: item.id,
                    label: 'MA' + item.id,
                })),
                loadOptions: input =>
                    this.loadOptions({
                        'submissions.id': { like: `%${input.replace(/\D/g, '')}%` },
                    }),
                filterType: DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_SINGLE,
                filterPlaceholder: 'data_table.filter.submission_id',
                type: DATA_TABLE_COLUMN_TYPE_HIDDEN,
                filterSize: 2,
                filterClassName: 'submissions-filter-id',
            },
            {
                key: 'status.status',
                col: { width: '9%' },
                title: 'data_table.status_id',
                sortable: true,
                filterable: false,
            },
            {
                key: 'virtual_status',
                col: { width: '9%' },
                title: 'data_table.virtual_status',
                sortable: true,
                filterable: false,
                type: DATA_TABLE_COLUMN_TYPE_PROCESS_STATUS,
            },
            {
                key: 'created_at',
                col: { width: '10%' },
                title: 'data_table.submission_created_at',
                sortable: true,
                filterable: false,
                handler: item => {
                    return formatDate(item.created_at);
                },
            },
            {
                key: 'updated_at',
                col: { width: '10%' },
                title: 'data_table.submission_updated_at',
                sortable: true,
                filterable: false,
                handler: item => {
                    return formatDate(item.updated_at);
                },
            },
            {
                key: 'created_at_from',
                filterKey: 'submissions.created_at',
                sortable: false,
                filterable: true,
                operator: 'gte',
                type: DATA_TABLE_COLUMN_TYPE_HIDDEN,
                filterType: DATA_TABLE_FILTER_TYPE_DATE,
                filterPlaceholder: 'data_table.filter.date.from',
                filterSize: 2,
                filterClassName: 'submissions-filter-from',
            },
            {
                key: 'created_at_to',
                filterKey: 'submissions.created_at',
                sortable: false,
                filterable: true,
                operator: 'lte',
                type: DATA_TABLE_COLUMN_TYPE_HIDDEN,
                filterType: DATA_TABLE_FILTER_TYPE_DATE,
                filterPlaceholder: 'data_table.filter.date.to',
                filterSize: 2,
                filterClassName: 'submissions-filter-to',
            },
            {
                key: 'process_status',
                sortable: false,
                filterable: true,
                type: DATA_TABLE_COLUMN_TYPE_HIDDEN,
                filterType: DATA_TABLE_FILTER_TYPE_SELECT,
                filterPlaceholder: 'data_table.filter.process_status',
                options: statusesData,
                value: null,
                filterSize: 3,
                filterClassName: 'submissions-filter-status',
            },
            {
                key: 'status_id',
                sortable: false,
                filterable: true,
                type: DATA_TABLE_COLUMN_TYPE_HIDDEN,
                filterType: DATA_TABLE_FILTER_TYPE_SELECT,
                filterPlaceholder: 'data_table.filter.status_id',
                options: phasesData
                    .filter(item => submissionsType !== 'active' || item.alias !== PHASE_PUBLISHED)
                    .map(item => ({
                        value: item.id,
                        label: item.status,
                    })) ,
                value: null,
                filterSize: 3,
                filterClassName: 'submissions-filter-state',
            },
            {
                key: 'search_title',
                filterKey: 'title',
                sortable: false,
                filterable: true,
                type: DATA_TABLE_COLUMN_TYPE_HIDDEN,
                filterType: DATA_TABLE_FILTER_TYPE_COMPLEX_STRING,
                filterPlaceholder: 'data_table.filter.title',
                filterSize: 5,
                search: true,
                onChange: (key, value) => this.handleChangeSearch(key, value),
                submitOnKeyPress: true,
                tmpFilter: where.title,
                filterClassName: 'submissions-filter-search-title',
            },
            {
                key: 'search_authors',
                filterKey: 'authors',
                sortable: false,
                filterable: true,
                type: DATA_TABLE_COLUMN_TYPE_HIDDEN,
                filterType: DATA_TABLE_FILTER_TYPE_COMPLEX_STRING,
                filterPlaceholder: 'data_table.filter.author.title',
                filterSize: 5,
                search: true,
                onChange: (key, value) => this.handleChangeSearch(key, value),
                submitOnKeyPress: true,
                tmpFilter: where.authors,
                filterClassName: 'submissions-filter-search-authors',
            },
        ];
    };

    getResetBtn() {
        return (
            <Button
                color="transparent"
                type="button"
                round
                onClick={() => this.resetToDefault()}
                customClass={'submission-filter-btn-reset'}
            >
                <RefreshIcon />
                <FormattedMessage id={'button.submissions.set_default'} />
            </Button>
        );
    }

    getStatusBtns() {
        const { isOverdue, isNew } = this.state;
        const {
            countData: { overdueCount, newCount },
        } = this.props;

        return (
            <div className={'btr'}>
                <Button
                    color={isOverdue ? 'rose' : 'white'}
                    type="button"
                    round
                    onClick={() => this.toggleStatus(true, false)}
                    customClass={'submission-filter-btn-overdue submissionBtn ' + (isOverdue ? 'phase-btn-active' : '')}
                >
                    <ScheduleIcon />
                    <FormattedMessage id={'button.submissions.overdue'} />
                    <span>{overdueCount ? overdueCount : ''}</span>
                </Button>
                <Button
                    color={isNew ? 'success' : 'white'}
                    type="button"
                    round
                    onClick={() => this.toggleStatus(false, true)}
                    customClass={'submission-filter-btn-new ' + (isNew ? 'phase-btn-active' : '')}
                >
                    <ArrowForwardIcon />
                    <FormattedMessage id={'button.submissions.new'} />
                    <span>{newCount ? newCount : ''}</span>
                </Button>

                {this.getFiltersBtn()}

                {this.getResetBtn()}
            </div>
        );
    }

    getFiltersBtn() {
        const { isFiltersOpen } = this.state;
        return (
            <Button
                color={isFiltersOpen ? 'warning' : 'white'}
                type="button"
                round
                onClick={() => this.setState({ isFiltersOpen: !this.state.isFiltersOpen })}
                customClass={'submission-filter-btn-toggle ' + (isFiltersOpen ? 'filters-btn-active' : '')}
            >
                <TuneIcon />
                <FormattedMessage id={'button.submissions.filters'} />
            </Button>
        );
    }

    getTabBtns() {
        const { allJournals } = this.state;
        return (
            <span>
                <Button
                    color={allJournals ? 'white' : 'rose'}
                    type="button"
                    onClick={() => this.toggleJournals(false)}
                    customClass={'submission-filter-btn-my-journals'}
                >
                    <FormattedMessage id={'button.submissions.my_journals'} />
                </Button>
                <Button
                    color={allJournals ? 'rose' : 'white'}
                    type="button"
                    onClick={() => this.toggleJournals(true)}
                    customClass={'submission-filter-btn-all-journals'}
                >
                    <FormattedMessage id={'button.submissions.all_journals'} />
                </Button>
            </span>
        );
    }

    getAdditionalFilterBlock() {
        const { updateFilter } = this.props;
        const { submissionsType, allJournals } = this.state;

        return (
            !allJournals && (
                <FormControl component="fieldset">
                    <RadioGroup
                        row
                        name="submissionsType"
                        aria-label="submissionsType"
                        value={submissionsType}
                        onChange={(event, submissionsType) =>
                            this.setState({ submissionsType }, () => updateFilter({ where: {status: this.getSubmissionType()}}))
                        }
                    >
                        <FormControlLabel
                            value="active"
                            control={<Radio />}
                            label={<FormattedMessage id={'field.submissions_active.label'} />}
                        />
                        <FormControlLabel
                            value="archive"
                            control={<Radio />}
                            label={<FormattedMessage id={'field.submissions_archive.label'} />}
                        />
                    </RadioGroup>
                </FormControl>
            )
        );
    }

    render() {
        const { data, filter, load, metadata, updateFilter, tmpFilter, isOneOf, loading, redirectToCreate } = this.props;
        const { isFiltersOpen, allJournals, filtersKey } = this.state;

        return (
            <div className={'www'}>
                {loading && <Loader/>}

                <div className="data-table-filters-wrap-block">
                    <div
                        className="data-table-title-block"
                        style={
                            isOneOf([ROLE_ADMIN, ROLE_CHIEF_EDITORIAL, ROLE_EDITORIAL, ROLE_EDITOR, ROLE_AUTHOR, ROLE_REVIEWER]) ? {} : { paddingTop: '20px' }
                        }
                    >
                        <FormattedMessage id={'title.submissions'} />
                    </div>
                    {isOneOf([ROLE_ADMIN, ROLE_CHIEF_EDITORIAL, ROLE_EDITORIAL, ROLE_EDITOR]) && (
                        <div
                            className={'data-table-filters-control-block ' + (allJournals ? 'all-journals-active' : '')}
                        >
                            {!allJournals && this.getStatusBtns()}
                            <span className={'pull-right'}>{this.getTabBtns()}</span>
                        </div>
                    )}
                    {isOneOf([ROLE_AUTHOR, ROLE_REVIEWER]) && (
                        <Button
                            color='primary'
                            type="button"
                            onClick={redirectToCreate}
                        >
                            <FormattedMessage id={'menu.submission_create'} />
                        </Button>
                    )}
                </div>
                <DataTable
                    columns={this.getColumns()}
                    metadata={(metadata && metadata.total) || allJournals ? metadata : {}}
                    data={data}
                    filter={this.getAuthFilter(filter)}
                    load={load}
                    updateFilter={updateFilter}
                    showFilters={ (isFiltersOpen || allJournals) && !isOneOf([ROLE_AUTHOR, ROLE_REVIEWER, ROLE_EDITORIAL_BOARD])}
                    icon={false}
                    separatedFilers
                    additionalFilterBlock={this.getAdditionalFilterBlock()}
                    sizedFilters
                    search={allJournals}
                    handleSearch={() => updateFilter(tmpFilter)}
                    customCardContentClass={
                        allJournals ? 'submissions-list-search-wrapper' : 'submissions-list-wrapper'
                    }
                    filtersKey={filtersKey}
                    footerMessage={<FormattedMessage id={'data_table.submissions.empty'} />}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/SubmissionsList/SubmissionsList.jsx